module.exports = __webpack_public_path__ + "static/img/tree.7439aa7.png";


//////////////////
// WEBPACK FOOTER
// ./static/img/tree.png
// module id = m85e
// module chunks = 1